module.exports = __webpack_public_path__ + "static/img/Wardlaw.f9a1214.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Wardlaw.jpg
// module id = KB8L
// module chunks = 0